import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { changeStatus, onFetchBussinesArea, onSetSelectedBussinesArea, selectBussinesAreaState, setAction } from "../redux/slices/bussinesAreaSlice"
import { BussinesAreaAPI } from "../apis/BussinesAreaAPI"
import { bussinesArea } from "../types/slices/bussinesAreaType"

export const useBussinesAreaStore = () => {

    const dispatch = useDispatch()
    const { bussinesArea, bussinesAreaSelected, status, action } = useSelector(selectBussinesAreaState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getBussinesArea = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await BussinesAreaAPI.getBussinesArea({search:search})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(onFetchBussinesArea(detail))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getBussinesAreaByCompany = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await BussinesAreaAPI.getBussinesAreaByCompany({search:search, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(onFetchBussinesArea(detail))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createBussinesArea = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await BussinesAreaAPI.createBussinesArea({...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const editBussinesArea = async (idbussinesArea: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await BussinesAreaAPI.editBussinesArea(idbussinesArea, {...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const changeStatusBusinessArea = async (idstore: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await BussinesAreaAPI.changeStatusBusinessArea(idstore, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteBussinesArea = async (idbranchoffice: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await BussinesAreaAPI.deleteBussinesArea(idbranchoffice)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedBussinesArea = (bussinesArea: bussinesArea) => {
        try {
            dispatch(onSetSelectedBussinesArea(bussinesArea))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionBussinesArea = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        bussinesArea,
        bussinesAreaSelected,
        status,
        action,
        //actions
        getBussinesArea,
        getBussinesAreaByCompany,
        createBussinesArea,
        editBussinesArea,
        changeStatusBusinessArea,
        deleteBussinesArea,
        setSelectedBussinesArea,
        setActionBussinesArea,
    }
}